angular.module("app").controller("FiltersAddIconPageController", [
    '$scope',
    '$uibModalInstance',
    'preloadedIcons',
    'selectedIcon',
    'iconsCategory',
    'logger',
    'pagination',
    'iconsService',
    'errorHandler',
    function ($scope, $modalInstance, preloadedIcons, selectedIcon, iconsCategory, logger, pagination, iconsService, errorHandler) {
        $scope.icons = preloadedIcons.icons.data;
        $scope.pagination = pagination.init(function () {
            $scope.updateList();
        }, preloadedIcons.icons.total, 25);

        $scope.showSearchResults = false;
        var selectedSearchTerm;
        $scope.searchTerm = "";

       $scope.selectedIcon = selectedIcon;

        $scope.ok = function () {
            if (!$scope.iconToUse) {
                logger.logError("global.pleaseSelectIcon");
                return;
            }
            $modalInstance.close($scope.iconToUse);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.useIcon = function (icon) {
            $scope.iconToUse = icon;
        };

        $scope.updateList = function updateList() {
            iconsService.getIconsList(iconsCategory, $scope.pagination.page, $scope.pagination.limit, $scope.searchTerm).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.icons = angular.copy(response.data);
                        $scope.pagination.totalItems = response.total;
                    } else {
                        errorHandler(response.message);
                        return [];
                    }
                }
            )
        };

    }
]);
